/**
 * Bootstrap component that
 * initiates Redux and any other
 * React-based dependencies.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import initiateStore from '../../store/store';

import Application from '../ApplicationContainer/ApplicationContainer';

class Bootstrap extends Component {
  constructor(props) {
    super(props);
    this.store = initiateStore();
  }

  render() {
    const {
      settings: {
        contentId,
        communityId,
        communityType,
        commentsContext = null,
        communities = null,
        socialFeedShowInput = null,
        topicId
      },
      theme
    } = this.props;
    const _communityId = communityId && parseInt(communityId, 10);
    const _contentId = contentId && parseInt(contentId, 10);

    return (
      <ThemeProvider theme={theme}>
        <ReduxProvider store={this.store}>
          <Application
            contentId={_contentId}
            communityId={_communityId}
            communityType={communityType}
            communities={communities}
            commentsContext={commentsContext}
            socialFeedShowInput={socialFeedShowInput}
            topicId={topicId}
          />
        </ReduxProvider>
      </ThemeProvider>
    );
  }
}

Bootstrap.propTypes = {
  settings: PropTypes.shape({
    contentId: PropTypes.number.isRequired,
    communityId: PropTypes.number.isRequired,
    company: PropTypes.string.isRequired,
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    ldKey: PropTypes.string,
    communityType: PropTypes.string,
    communities: PropTypes.string,
    commentsContext: PropTypes.string,
    socialFeedShowInput: PropTypes.bool,
    topicId: PropTypes.number
  }).isRequired,
  theme: PropTypes.shape({
    colours: PropTypes.shape({
      base: PropTypes.string,
      light: PropTypes.string,
      dark: PropTypes.string
    })
  }).isRequired
};

export default Bootstrap;
